import Phonemain from '@/pages/PhoneServiceMain'
import PhoneHail from '@/pages/hailTaxi/PhoneHail'
import RecordHailBill from '@/pages/recordHail/RecordHailBill'
import ReservationList from '@/pages/reservation/ReservationList'

export default [
  {
    path: '/phonemain',
    name: 'Phonemain',
    component: Phonemain,
    children: [
      {
        path: 'phoneHail',
        name: 'ServicePhoneHail',
        component: PhoneHail,
        meta: {
          title: '電話派車',
        },
      },
      {
        path: 'RecordHailBill',
        name: 'RecordHailBill',
        component: RecordHailBill,
        meta: {
          title: '後派單',
        },
      },
      {
        path: 'ReservationList',
        name: 'ReservationList',
        component: ReservationList,
        meta: {
          title: '預約單',
        },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/pages/page_404.vue'),
  },
  {
    path: '*',
    redirect: '/404',
  },
]



// WEBPACK FOOTER //
// ./src/router/phoneServiceRoutersTable.js